import { alpha as t } from "@mui/material";
import * as m from "cartocolor";
const s = "#2C3032", c = "#FFFFFF", l = "#e91e63", e = {
  common: {
    black: s,
    white: c
  },
  neutral: {
    50: "#f8f9f9",
    100: "#e1e3e4",
    200: "#cbcdcf",
    300: "#b4b8ba",
    400: "#9da2a6",
    500: "#868d91",
    600: "#6f777c",
    700: "#595f63",
    800: "#43474a",
    900: s,
    A100: "#ddddde",
    A200: "#b9babb",
    A400: "#7c7e7f",
    A700: "#16191A"
  },
  blue: {
    100: "#B9DAF9",
    200: "#5DB2F6",
    300: "#358BE7",
    400: "#036FE2",
    500: "#024D9E"
  },
  green: {
    300: "#6BE2AD",
    400: "#47DB99",
    500: "#31996B"
  },
  lightGreen: {
    300: "#8CB24A",
    400: "#709F1D",
    500: "#435F11"
  },
  indigo: {
    300: "#34689F",
    400: "#024388",
    500: "#012C5A"
  },
  orange: {
    300: "#F4B134",
    400: "#F29E02",
    500: "#A96E01"
  },
  red: {
    300: "#CD593B",
    400: "#C1300B",
    500: "#872107"
  },
  qualitative: {
    // CARTO colors
    // TODO: Related discussion https://app.shortcut.com/cartoteam/story/264834/
    bold: {
      0: "#7F3C8D",
      1: "#11A579",
      2: "#3969AC",
      3: "#F2B701",
      4: "#E73F74",
      5: "#80BA5A",
      6: "#E68310",
      7: "#008695",
      8: "#CF1C90",
      9: "#f97b72",
      10: "#4b4b8f",
      11: "#A5AA99"
    }
  },
  shades: {
    dark: {
      90: t(s, 0.9),
      60: t(s, 0.6),
      40: t(s, 0.4),
      25: t(s, 0.25),
      12: t(s, 0.12),
      8: t(s, 0.08),
      4: t(s, 0.04)
    },
    light: {
      90: t(c, 0.9),
      60: t(c, 0.6),
      40: t(c, 0.4),
      25: t(c, 0.25),
      12: t(c, 0.12),
      8: t(c, 0.08),
      4: t(c, 0.04)
    }
  }
}, u = {
  mode: "light",
  contrastThreshold: 3,
  tonalOffset: 0.2,
  common: { ...e.common },
  primary: {
    main: e.blue[400],
    dark: e.blue[500],
    light: e.blue[300],
    contrastText: e.common.white,
    background: t(e.blue[400], 0.08),
    relatedLight: "#EAF2FC",
    relatedDark: l
  },
  secondary: {
    main: e.green[400],
    dark: e.green[500],
    light: e.green[300],
    contrastText: e.common.black,
    background: t(e.green[400], 0.08),
    relatedLight: "#EFFCF5",
    relatedDark: l
  },
  text: {
    primary: e.common.black,
    secondary: e.shades.dark[60],
    disabled: e.shades.dark[25],
    hint: e.shades.dark[40]
  },
  background: {
    paper: e.common.white,
    default: e.neutral[50]
  },
  action: {
    active: e.shades.dark[40],
    hover: e.shades.dark[8],
    disabledBackground: e.neutral[100],
    disabled: e.shades.dark[25],
    selected: e.shades.dark[12],
    focus: e.shades.dark[12],
    activatedOpacity: 0.12,
    hoverOpacity: 0.04,
    selectedOpacity: 0.08,
    disabledOpacity: 0.38,
    focusOpacity: 0.12
  },
  info: {
    main: e.indigo[400],
    dark: e.indigo[500],
    light: e.indigo[300],
    contrastText: e.common.white,
    relatedDark: "#0D2B4A",
    relatedLight: "#E9EEF4",
    background: l
  },
  success: {
    main: e.lightGreen[400],
    dark: e.lightGreen[500],
    light: e.lightGreen[300],
    contrastText: e.common.white,
    relatedDark: "#3D541A",
    relatedLight: "#F2F5EB",
    background: l
  },
  warning: {
    main: e.orange[400],
    dark: e.orange[500],
    light: e.orange[300],
    contrastText: e.common.black,
    relatedDark: "#78540F",
    relatedLight: "#FEF6EA",
    background: l
  },
  error: {
    main: e.red[400],
    light: e.red[300],
    dark: e.red[500],
    contrastText: e.common.white,
    relatedDark: "#622215",
    relatedLight: "#F9EDEA",
    background: l
  },
  grey: {
    ...e.neutral
  },
  divider: e.shades.dark[12],
  // Custom common colors
  default: {
    main: e.neutral[100],
    dark: e.neutral[200],
    light: e.neutral[50],
    outlinedBorder: e.shades.dark[25],
    background: e.shades.dark[4],
    relatedLight: l,
    relatedDark: l,
    contrastText: l
  },
  brand: {
    navyBlue: "#162945",
    locationRed: "#EB1510",
    predictionBlue: "#1785FB",
    softBlue: "#F2F6F9",
    appBarMain: "#162945",
    appBarContrastText: e.common.white
  },
  white: {
    ...e.shades.light
  },
  black: {
    ...e.shades.dark
  },
  qualitative: {
    ...e.qualitative
  }
};
function F(r, a) {
  var b;
  const n = m[r];
  let o = a;
  if (!n)
    throw new Error(
      `Palette "${r}" not found. Expected a CARTOColors string`
    );
  const i = Object.keys(n).filter((k) => k !== "tags").map(Number), d = Math.max(...i), g = Math.min(...i);
  !Number.isInteger(a) || a > d ? o = d : a < g && (o = g);
  let h = n[o];
  return (b = n.tags) != null && b.includes("qualitative") && (h = h == null ? void 0 : h.slice(0, -1)), h;
}
function A(r, a) {
  return typeof r == "string" ? F(r, a) : r.map((n) => {
    if (Array.isArray(n)) {
      const [o, i, d] = n;
      return f(o, i, d);
    } else
      return n;
  });
}
function f(r, a, n) {
  return "#" + ((1 << 24) + (r << 16) + (a << 8) + n).toString(16).slice(1);
}
function B(r, a) {
  var d;
  const n = (d = u == null ? void 0 : u.qualitative) == null ? void 0 : d.bold, o = Object.values(n ?? {}), i = a % o.length;
  return {
    backgroundColor: o[i],
    color: r.palette.getContrastText(o[i])
  };
}
function E(r, {
  palette: a,
  fallbackColor: n,
  colorMapping: o
}) {
  if (o[r])
    return o[r];
  if (!a || a.length === 0)
    return n;
  const d = Math.min(
    Object.keys(o).length,
    a.length - 1
  ), g = a[d];
  return o[r] = g, g;
}
export {
  E as a,
  A as b,
  u as c,
  B as g
};
